import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { StepperIndustryKey } from '../types';

interface StepperQueryParams {
	accountManagers?: string;
	comment?: string;
	countryCode?: string;
	email?: string;
	externalAccountNumber?: string;
	externalOwnerAccountId?: string;
	fullName?: string;
	googleMapUrl?: string;
	hashExternalAccountId?: string;
	industry?: StepperIndustryKey;
	language?: string;
	notifications?: string;
	phoneNumber?: string;
	promoCode?: string;
	queryPartnerIdn?: string;
	queryPartnerMemberIdn?: string;
	queryParamsString: string;
	referral?: string;
	source?: string;
	technicalOwners?: string;
}

const isStepperIndustryKey = (value?: string): value is StepperIndustryKey =>
	Object.values(StepperIndustryKey).includes(value as StepperIndustryKey);

const useStepperQueryParams = (): StepperQueryParams => {
	const [searchParams] = useSearchParams();

	return useMemo(() => {
		const {
			account_managers: accountManagers,
			comment,
			country_code: countryCode,
			email,
			external_account_number: externalAccountNumber,
			external_owner_account_id: externalOwnerAccountId,
			full_name: fullName,
			google_map_url: googleMapUrl,
			hash_external_account_id: hashExternalAccountId,
			industry,
			language,
			notifications,
			partner_idn: queryPartnerIdn,
			partner_member_idn: queryPartnerMemberIdn,
			phone_number: phoneNumber,
			promo_code: promoCode,
			referral,
			source,
			technical_owners: technicalOwners,
			...params
		} = Object.fromEntries(searchParams.entries());

		return {
			accountManagers,
			comment,
			countryCode,
			email,
			externalAccountNumber,
			externalOwnerAccountId,
			fullName,
			googleMapUrl,
			hashExternalAccountId,
			industry: isStepperIndustryKey(industry) ? industry : undefined,
			language,
			notifications,
			phoneNumber,
			promoCode,
			queryPartnerIdn,
			queryPartnerMemberIdn,
			queryParamsString: JSON.stringify(params),
			referral,
			source,
			technicalOwners
		};
	}, [searchParams]);
};

export type { StepperQueryParams };

export default useStepperQueryParams;
